module.exports = __webpack_public_path__ + "static/media/jordan.ec1487d9.jpeg";